import { settings } from '@/api/config';
import { getInitData } from '@/utils/getInitData';
import axios from 'axios';

export const getAdsgramBanTime = async () => {
  const tg = window?.Telegram?.WebApp;
  if (!tg?.initData) {
    throw new Error('Telegram WebApp не инициализирован');
  }

  try {
    const encodedInitData = encodeURIComponent(getInitData());
    const response = await axios.get(
      `${settings.url}api/banners/get/last/adsgramcpc?initData=${encodedInitData}`,
    );
    return response.data;
  } catch (error) {
    console.error('Ошибка при получении задач:', error);
    throw error;
  }
};
